module.exports = __webpack_public_path__ + "static/img/79053A_3_R_20191118_fit.59b7405.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/79053A_3_R_20191118_fit.png
// module id = 3Ove
// module chunks = 0